
import './DeleteInputFormsForAnswerTrouble.scss';
import { closeDeleteInputFormsForAnswerTrouble } from '../troubleslice';

const DeleteInputFormsForAnswerTrouble  = (props) => {
const {dispatch} = props;
  
 // CLICK OK
const onSend = () => {

        props.handledeleteAnswerTrouble();
}


// CLOSE FORM
const onClose = () => {
   
    dispatch(closeDeleteInputFormsForAnswerTrouble());

}


   
        return (
        
        
            
                <div className="DeleteInputFormsForAnswerTrouble">

                    <p>Вы действительно хотите удалить ответ?</p>
                    <div className='row-block'>
                        <button onClick={onSend}>Да</button>
                        <button onClick={onClose}>Отмена</button>
                    </div>
                    
                </div>
        
        
        
        
        )
       
    
}
export default DeleteInputFormsForAnswerTrouble;